import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { AuthCustomService } from './auth-custom.service';

@Component({
    selector: 'auth',
    styleUrls: ['./auth-custom.component.scss'],
    templateUrl: 'auth-custom.component.html'
})
export class AuthCustomComponent implements OnInit {

    public principalLogin = null;
    public secundarioLogin = null;
    public customLogin = null;

    constructor(
        private service: AuthCustomService,
        private spinnerService: NgxSpinnerService,
        private notifications: NotificationsService,
    ) { }

    ngOnInit(): void {

        this.customerWL();
    }

    renderBackgroundImage() {
        if (this.customLogin.imagemBackgroundLogin != null) {
            document.getElementById("background").style.backgroundImage = 'url(data:image/png;base64,' + this.customLogin.imagemBackgroundLogin + ')';
            document.getElementById("background").className = "img-backgroud-login";
        }
    }

    colorTextoLogin() {
        if (this.customLogin.corTextoLogin != null) {
            document.getElementById("textoPrincipal").style.color = this.customLogin.corTextoLogin;
            document.getElementById("textoSecundario").style.color = this.customLogin.corTextoLogin;
        }
    }

    customerWL() {

        this.spinnerService.show();

        let urlClient = window.location.href;
        let params = new HttpParams();
        params = params.append('urlClient', urlClient);

        this.service.customerWL(
            params,
            (response) => {

                localStorage.setItem('bway-url', urlClient);
                localStorage.setItem('bway-Session-Time', response.idleSessionTimePortal);
                document.title = response.textNamePortal;
                this.customLogin = {
                    logo: response.imageLogin,
                    headerMenu: response.iconAreaLoggedPortal,
                    primaria: response.colorPrimaryButton,
                    secundaria: response.colorSecondaryButton,
                    terciario: response.colorTertiaryButton,
                    home: response.colorMenuPortal,
                    label: response.colorLabel,
                    title: response.textNamePortal,
                    whatsapp: response.numberWhatsApp,
                    cardProduto: response.colorCardProduct,
                    alertError: response.colorAlertErrorPortal,
                    alertSucesso: response.colorAlertSucessPortal,
                    backgroundPortal: response.colorBackgroundPortal,
                    iconPage: response.iconPage,
                    urlCustomer: response.urlCustomer,
                    textWhatsApp: response.textServiceWhatsApp,
                    imagemBackgroundLogin: response.imagemBackgroundLogin,
                    textoPrincipalLogin: response.textoPrincipalLogin,
                    textoSecundarioLogin: response.textoSecundarioLogin,
                    corTextoLogin: response.corTextoLogin
                }
                localStorage.setItem('bway-customLogin', JSON.stringify(this.customLogin));

                this.principalLogin = this.customLogin.textoPrincipalLogin;
                this.secundarioLogin = this.customLogin.textoSecundarioLogin;
                this.renderBackgroundImage();
                this.colorTextoLogin();
                this.spinnerService.hide();

            }, (error) => {
                this.spinnerService.hide();
                this.notifications.error(error.error.message)
            });
    }
}